// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_32AB4eXVr7_J2OBicu_V0p","rightContainer":"_10yhreGhWLFVG80P5lK4c-","win":"_3ZzmGykvuyRs0meC64R-DG","winTextNonSymbolCurrency":"_3wQz7fbmUWbexcKHb0h6SE","lose":"_3OKd6JRuPBYBC4ghH9rjO7","eventContainer":"_1MQl8LuzosFulV1ZnMtw0m","team":"_3F0F-g6BMTxzP4rdv2p_-H","timer":"_2pmbu6fZGmaTRgr9249dwZ","score":"_31wcZBs6OuS203kXEz7MBM"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/resultCardMatchday.css
// module id = 781
// module chunks = 0